import React from 'react'
import "@fontsource/roboto";
import {Linking} from "react-native";

const onPressPlaystore = () => {
    Linking.openURL("https://play.google.com/store/apps/developer?id=Octa+Technology").catch(err => console.error("Couldn't load page", err));
};

const Title = () => {
    return (
         <div>
            <footer>
                <section class="grid-columns three">
                <div class="footer-text">
                    <p>1* <b>Privacy Policy :</b> We value your information and so we keep it private. All names, addresses and shopping activity/habits collected will only be used to keep our platform better your experience and not sold to third parties.</p>
                    <p>2* <b>Image Credits :</b> We do not intend to infringe any copyrights with the images used on the our sites. You may long click on an image to see it's creator, and if you would love your images taken down, please contact us.</p>
                    <p>3* <b>Sales and Refunds :</b> If your item arrives not as described, we’ll work with you and the seller to make it right.</p>
                    <p>We are a start-up tech company and are trying our best to keep our services up-to your sutisfuction, please eamil the developer for any suggestions and tips. Thank you for shopping with us.</p>

                    <br/>

                    <h5>Republic of Zambia</h5>
                    <p>Copyright 2022 Octa Technology. All rights reserved.</p>

                    <br/>
                    <img src={require('../images/playstorebtn.png')} width="125" height="41" alt="Download on playstore button" loading="lazy" decoding="async" onClick={onPressPlaystore}/>
                </div>
                <div>
                    <h5>Products</h5>
                    <ul>
                    <li><a href="https://play.google.com/store/apps/details?id=com.octa.imaginary" target="_blank">Imaginary Art Store</a></li>
                    <li><a href="https://play.google.com/store/apps/details?id=com.octa.imaginaryartist" target="_blank">Imaginary Artists</a></li>
                    </ul>
                </div>
                <div>
                    <h5>Follow us</h5>
                    <ul>
                    <li><a href="https://www.instagram.com/imaginary_art_store/" target="_blank">Instagram</a></li>
                    <li><a href="https://twitter.com/OctaTechnology" target="_blank">Twitter</a></li>
                    </ul>
                </div>
                </section>




            </footer>
         </div>
        
    )
}

export default Title
